/** Time-of-day greeting from browser local time. Never "Welcome Back". */

export function timeOfDayGreeting(now = new Date()): 'morning' | 'afternoon' | 'evening' | 'night' {
  const h = now.getHours()
  if (h >= 5 && h < 12) return 'morning'
  if (h >= 12 && h < 17) return 'afternoon'
  if (h >= 17 && h < 21) return 'evening'
  return 'night'
}

export function greetingTitle(firstName: string, now = new Date()): string {
  const name = (firstName || '').trim()
  const period = timeOfDayGreeting(now)
  const label =
    period === 'morning'
      ? 'Good Morning'
      : period === 'afternoon'
        ? 'Good Afternoon'
        : period === 'evening'
          ? 'Good Evening'
          : 'Good Night'
  return name ? `${label}, ${name}` : label
}

/** Subtitle by local time — no fake market claims. */
export function greetingSubtitle(_hasLive = false, now = new Date()): string {
  const period = timeOfDayGreeting(now)
  if (period === 'morning') return 'Ready for the trading day?'
  if (period === 'afternoon') return "Here's your trading overview."
  if (period === 'evening') return 'Review your trading activity.'
  return 'Your trading account is ready when you are.'
}
